<template>
  <div class="container-fluid bg-warning text-white">
    <div class="row title-card">
      <div class="col-10 text-left"><span><icon name="cog" scale="2.5" spin v-show="spinner"></icon>{{ abertos.size }}</span> <h4>Trabalhando</h4></div>
      <div class="col-2 text-right"><b-link class="text-white" :to="{ name: 'home' }"><icon name="times" scale="2"></icon></b-link></div>
    </div>
    <div class="row pb-4" v-if="level == 'supervisor'">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-center">
        <select class="custom-select" v-model="store" @change="setStore()">
                <option value="all">Todas as Lojas</option>
                <option v-for="(store, index) in stores" v-bind:key="'store-'+index" v-bind:value="store.id_store">{{ store.nm_store }}</option>
        </select>
      </div>
    </div>
    <div class="row mt-2" v-for="(aberto, index) in abertos.checks" v-bind:key="'abertos-'+index" v-bind:id="'aberto-'+index">
      <div class="col-2 col-md-1 col-lg-1 offset-md-2 offset-lg-3 offset-xl-3 text-center"><strong class="d-block">{{ aberto.days }}</strong> <span v-if="aberto.days == 1">dia</span><span v-if="aberto.days > 1">dias</span></div>
      <div class="col-8 col-md-6 col-lg-4">
          <span>{{ aberto.nm_check }}</span>
          <icon id="newPost" name="circle" scale="0.7" v-if="aberto.new_post > 0"></icon>
          <h5>{{ aberto.nm_store }}</h5></div>
      <div class="col-2 col-md-1 col-lg-1 text-center"><b-link class="text-white" :to="{ name: 'check', params: { type: 'aberto', store: aberto.id_store, check: aberto.id_check }}"><icon name="edit" scale="2"></icon></b-link></div>
    </div>
  </div>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'
import Icon from 'vue-awesome'

export default {
  components: { Icon },
  data () {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      spinner: true,
      store: localStorage.getItem('global-store'),
      stores: [],
      abertos: []
    }
  },
  beforeCreate: function() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted () {
    http.get('/store/own').then(response => { this.stores = response.data; })
    http.get('/checks/abertos/'+this.admin+'/'+localStorage.getItem('global-store'))
    .then(response => {
        this.spinner = false;
        this.abertos = response.data;
    })
    .catch(error => {
      swal({
        type: 'error',
        title: 'Erro...',
        text: error.response.data.mensagem
      })
    })
  },
  methods: {
    setStore () {
        localStorage.setItem('global-store', this.store)
        location.reload()
    }
  }
}
</script>

<style scoped>
.container-fluid { min-height:100vh; }
.container-fluid .title-card { padding:20px 0; }
.container-fluid .title-card span { display:block; width:40px; height:40px; float:left; border-radius:20px; font-size:20px; color:#FFC107; background:#FFF; line-height:40px; text-align:center; margin-right:24px; }
.container-fluid .title-card h4 { font-size:1.5em; color:#FFF; line-height:40px; }
#newPost{
    color: #DC3545;
    text-align:center;
    margin-left: 3px;
    margin-bottom: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/Abertos.vue